import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { GET_CONFIGURATION_FACILITY, NEW_FACILITY_IDS } from "./configTypes";
import { get } from "../../api";
import { GET_CONF_FACILITY } from "../../api/apiRoutes";

export const getConfigurationFacility = createAsyncThunk(
  GET_CONFIGURATION_FACILITY,
  async (facilityIds: string) => await get(GET_CONF_FACILITY(facilityIds))
);

export const updateFacilityIds = createAction<string>(NEW_FACILITY_IDS);

